/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue/dist/vue.esm.js'
import axios from 'axios';
import bus from '../bus.js';
import { store } from '../store';
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

const __vue_script__ = {
	methods: {
		closeModal() {
			bus.$emit( 'hideModal', 'true' );
		},
	},
	data () {
		return {
			modalContent: '',
			modalPic: '',
			modalTrackName: '',
		}
	},
	computed: {
		track() {
			return this.$store.getters.getAddToCartTrack;
		},
	},
	created: function () {
		let vm = this;

		bus.$on( 'updateModalPic', ( text ) => {
			vm.modalPic = text;
		});
	}
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeModal),expression:"closeModal"}],staticClass:"modal-container add-to-cart-modal-container"},[_c('button',{staticClass:"close",attrs:{"aria-label":"close"},on:{"click":_vm.closeModal}},[_c('svg',{staticClass:"svg-inline--fa fa-times fa-w-11",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"times","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 352 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"}})])]),_vm._v(" "),_c('div',{staticClass:"modal-top-half"},[_c('img',{staticClass:"modal__track-pic",attrs:{"src":_vm.modalPic}}),_vm._v(" "),_c('div',{staticClass:"modal__track-details"},[_c('h4',[_vm._v(_vm._s(_vm.track.title))]),_vm._v(" "),_c('div',{staticClass:"modal-part-heading"},[(_vm.track.genre.length >= 1)?_c('div',{staticClass:"modal-part-genres"},[_c('p',{staticClass:"modal-header"},[_vm._v("Genre")]),_vm._v(" "),_vm._l((_vm.track.genre),function(genre){return _c('span',{staticClass:"modal-genre"},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(genre)+"\n\t\t\t\t\t\t\t")])})],2):_vm._e(),_vm._v(" "),(_vm.track.bpm)?_c('div',{staticClass:"modal-part-bpm"},[_c('p',{staticClass:"modal-header"},[_vm._v("BPM")]),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.track.bpm))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal-content add-to-cart-modal-content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.track.cartBtns)}})])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AddToCartModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__